"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Feed = exports.FEED_BOOLEANS = void 0;
exports.FEED_BOOLEANS = [
    "managedByKol",
    "enabled"
];
class Feed {
    constructor(data) {
        this.id = null;
        this.name = null;
        this.url = null;
        this.type = null;
        this.image = null;
        this.classFormatter = null;
        this.updatedAt = null;
        this.managedByKol = false;
        this.enabled = false;
        this._$areas = [];
        if (data) {
            this.hydrate(data);
            if (typeof data.areas !== "undefined" && data.areas !== null) {
                this._$areas = data.areas;
            }
        }
    }
    hydrate(data) {
        for (const prop in data) {
            if (Object.prototype.hasOwnProperty.call(this, prop) && Object.prototype.hasOwnProperty.call(data, prop)) {
                if (exports.FEED_BOOLEANS.includes(prop)) {
                    this[prop] = Boolean(parseInt(data[prop]));
                }
                else {
                    this[prop] = data[prop];
                }
            }
        }
    }
}
exports.Feed = Feed;
//# sourceMappingURL=Feed.js.map